import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface InitialSate {
	pageTitle: string
	orderIds: Array<string | number>
	legalPersonId: string | number
	naturalPersonId: string | number
	refuellingsId: string | number
	partiesId: string | number
	isFop: boolean
	permissions: string[]
}

const initialState: InitialSate = {
	pageTitle: '',
	orderIds: [],
	legalPersonId: '',
	naturalPersonId: '',
	refuellingsId: '',
	partiesId: '',
	isFop: false,
	permissions: [],
}

const commonSlice = createSlice({
	name: 'common',
	initialState,
	reducers: {
		setPageTitle(state, action: PayloadAction<string>) {
			state.pageTitle = action.payload
		},
		setOrderId({ orderIds }, action: PayloadAction<string | number>) {
			const orderId = action.payload

			const index = orderIds?.findIndex((id) => id === orderId)

			if (index !== -1) {
				orderIds?.splice(index, 1)
			} else {
				orderIds?.push(orderId)
			}
		},
		setLegalPersonId(state, action: PayloadAction<string | number>) {
			state.legalPersonId = action.payload
		},
		setNaturalPersonId(state, action: PayloadAction<string | number>) {
			state.naturalPersonId = action.payload
		},
		setRefuellingsId(state, action: PayloadAction<string | number>) {
			state.refuellingsId = action.payload
		},
		setPartiesId(state, action: PayloadAction<string | number>) {
			state.partiesId = action.payload
		},
		setIsFop(state, action: PayloadAction<boolean>) {
			state.isFop = action.payload
		},
		setPermissions(state, action: PayloadAction<string[]>) {
			state.permissions = action.payload
		},
	},
})

export const commonActions = commonSlice.actions
export const commonReducer = commonSlice.reducer
